<template>
  <div id="app">
    <div class="waka-content">
    <router-view />
    </div>
    <WakaNotification  :notification="notification"/>
  </div>
</template>
<script>
import WakaNotification from '@/components/WakaNotification.vue'
export default {
  name: 'App',
  components: {
    WakaNotification
  },
  data () {
    return {
      message: '',
      notification: { message: '', isActive: false, isSuccess: false }
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.getCurrentUser
    },
    environment () {
      return this.$store.getters.getEnvironment
    },
    classEnv () {
      return this.environment === 'TEST' ? 'is-danger' : 'is-light'
    }
  },
  async created () {
    // try {
    //   await this.$store.dispatch('initialize')
    // } catch (err) {
    //   this.message = err
    //   this.showDismissibleAlert = 4
    // }
    window.onerror = function (msg, url, line, col, error) {
      this.javascriptNotification = { message: error.message, isActive: true, isSuccess: false }
    }
  },
  methods: {
  }
}
</script>
